import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { Col, FormLabel, Button, FormControl } from 'react-bootstrap';
import { FieldControl, Validators, FormControl as ReactiveFormControl, FieldGroup } from 'react-reactive-form';
import Select, { components } from 'react-select';
import { Ioption, IshoppingCartItem } from '../../../models';

const QuantityInput = ({ handler, touched, hasError, meta, pristine, errors, submitted }: ReactiveFormControl) => {
    return (
        <FormControl
            style={{ width: '100%' }}
            placeholder={meta.placeholder}
            type="number"
            name="quantity"
            onWheel={(e: React.WheelEvent<HTMLInputElement>) => e.currentTarget.blur()}
            {...handler()}
        />
    );
};

// Custom control component without form-control class to avoid conflicts
const ControlComponent = (props: any) => <components.Control {...props} />;

export const getBundleOptions = () => {
    let bundleOptions: Ioption[] = [];
    for (let index = 0; index < 6; index++) {
        bundleOptions = [...bundleOptions, { label: `${index + 1}`, value: index + 1 }];
    }
    return bundleOptions;
};

const BundleSelect = ({ handler, touched, hasError, meta, pristine, errors, submitted }: ReactiveFormControl) => {
    const customStyles = {
        control: (provided: any, state: any) => ({
            ...provided,
            minHeight: '42px',
            height: '42px',
            borderRadius: '8px',
            fontSize: '1.2em',
            fontWeight: 400,
            fontFamily: 'inherit',
            color: '#777',
            backgroundColor: '#fff',
            border: '1px solid #ced4da',
            boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(0,123,255,.25)' : 'none',
            '&:hover': {
                borderColor: '#ced4da'
            }
        }),
        valueContainer: (provided: any) => ({
            ...provided,
            height: '42px',
            padding: '0 12px'
        }),
        input: (provided: any) => ({
            ...provided,
            margin: '0',
            padding: '0',
            color: '#777'
        }),
        singleValue: (provided: any) => ({
            ...provided,
            color: '#777',
            fontSize: '1.2em'
        }),
        indicatorsContainer: (provided: any) => ({
            ...provided,
            height: '42px'
        }),
        indicatorSeparator: () => ({
            display: 'none'
        }),
        dropdownIndicator: (provided: any) => ({
            ...provided,
            padding: '8px',
            color: '#777'
        })
    };

    return (
        <Select
            options={getBundleOptions()}
            components={{ Control: ControlComponent }}
            classNamePrefix="react-select"
            name={meta.name || ''}
            isClearable={false}
            styles={customStyles}
            {...handler()}
        />
    );
};

export const ShoppingCartSubSubItem = ({
    subItemName,
    subSubItem,
    deleteAction,
    cartName,
    main = false
}: {
    subItemName?: string;
    subSubItem: IshoppingCartItem;
    deleteAction: (id: string, cartName: string) => void;
    cartName: string;
    main?: boolean;
}) => (
    <>
        <Col xs={5} style={{ margin: main ? '3px 0' : '0', display: 'flex', alignItems: 'center' }}>
            <FormLabel style={{ marginBottom: 0 }}>
                {subItemName && (
                    <span style={{ textTransform: 'capitalize' }}>
                        {subItemName} <br />
                    </span>
                )}
                <span>
                    <strong>PART:</strong> {subSubItem.name}
                </span>
            </FormLabel>
        </Col>

        <FieldGroup
            name={subSubItem.id}
            render={() => {
                return (
                    <>
                        <Col xs={3} style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ flex: '1 1 auto' }}>
                                <FieldControl
                                    name="bundle"
                                    render={BundleSelect as any}
                                    formState={{
                                        label: `${subSubItem.bundle}`,
                                        value: subSubItem.bundle
                                    }}
                                />
                            </div>
                        </Col>
                        <Col xs={4} style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <div style={{ flex: '1 1 auto' }}>
                                <FieldControl
                                    name="quantity"
                                    options={{
                                        validators: Validators.required
                                    }}
                                    render={QuantityInput as any}
                                    formState={subSubItem.quantity}
                                />
                            </div>
                            <Button
                                variant="link"
                                style={{
                                    fontSize: '1.6em',
                                    padding: '0',
                                    lineHeight: '1',
                                    minWidth: '24px'
                                }}
                                onClick={() => deleteAction(subSubItem.id, cartName)}
                            >
                                <FontAwesomeIcon icon={['far', 'times']} />
                            </Button>
                        </Col>
                    </>
                );
            }}
        />
    </>
);
